import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <>
      <div className="footer">
        <p>Fizjotrener &copy; 2020</p>
      </div>
    </>
  );
}

export default Footer;
